import { render } from "./PortfolioItem.vue?vue&type=template&id=21fa1a7c&scoped=true"
import script from "./PortfolioItem.vue?vue&type=script&lang=js"
export * from "./PortfolioItem.vue?vue&type=script&lang=js"

import "./PortfolioItem.vue?vue&type=style&index=0&id=21fa1a7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fa1a7c"]])

export default __exports__